import React from 'react';

const Internet = props => (
  <svg
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 16 17"
    preserveAspectRatio="xMidYMid"
    style={{
      enableBackground: 'new 0 0 16 17'
    }}
    xmlSpace="preserve"
    {...props}
  >
    <style>{'.st5{fill:none;stroke:#bcc6ca;stroke-linecap:round;stroke-linejoin:round}'}</style>
    <path className="st5" d="M2.3 7.1c3-3.1 8-3.2 11.1-.2.1.1.2.1.2.2" />
    <path className="st5" d="M15.9 4.4C11.7 0 4.7-.1.3 4.1c-.1.1-.2.2-.2.3M4.6 10.5c1.8-1.9 4.8-1.9 6.7-.1l.1.1" />
    <path
      className="st5"
      d="M13.6 7.1c-3-3.1-8-3.2-11.1-.2l-.2.2M11.4 10.5c-1.8-1.9-4.8-1.9-6.7-.1l-.1.1M8 12.8c.9 0 1.6.7 1.6 1.6 0 .9-.7 1.6-1.6 1.6s-1.6-.7-1.6-1.6c0-.9.7-1.6 1.6-1.6h0z"
    />
  </svg>
);

export default Internet;
